import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  MainForm,
  ManageCompaniesForm,
  ManageOrganizationsForm,
  ManageUsersForm,
} from './components'
import { Button } from '@material-ui/core'

const SSOCorporateGroupForm = ({
  edit = false,
  show = false,
  ssoCorporateGroup = {},
  refresh = () => {},
}) => {
  const [refreshAll, setRefreshAll] = useState(false)
  const history = useHistory()
  const checkIsDPOnetPlatform = (platform) =>
    platform === 'dponet' || platform === 'both'

  const checkIsAdvisorPlatform = (platform) =>
    platform === 'advisor' || platform === 'both'

  const [isDPOnetPlatform, setIsDPOnetPlatform] = useState(
    checkIsDPOnetPlatform(ssoCorporateGroup?.platform),
  )
  const [isAdvisorPlatform, setIsAdvisorPlatform] = useState(
    checkIsAdvisorPlatform(ssoCorporateGroup?.platform),
  )

  const handlePlatformChange = (platform) => {
    setIsDPOnetPlatform(checkIsDPOnetPlatform(platform))
    setIsAdvisorPlatform(checkIsAdvisorPlatform(platform))
  }

  const handleGoBack = () => {
    history.goBack()
  }

  return (
    <>
      <MainForm
        ssoCorporateGroup={ssoCorporateGroup}
        show={show}
        edit={edit}
        handlePlatformChange={handlePlatformChange}
        refresh={refresh}
      />
      {!!ssoCorporateGroup?.id && (
        <>
          {isDPOnetPlatform && (
            <ManageCompaniesForm
              ssoCorporateGroup={ssoCorporateGroup}
              show={show}
              setRefreshAll={setRefreshAll}
              refreshAll={refreshAll}
            />
          )}
          {isAdvisorPlatform && (
            <ManageOrganizationsForm
              ssoCorporateGroup={ssoCorporateGroup}
              show={show}
              setRefreshAll={setRefreshAll}
              refreshAll={refreshAll}
            />
          )}
          <ManageUsersForm
            ssoCorporateGroup={ssoCorporateGroup}
            show={show}
            setRefreshAll={setRefreshAll}
            refreshAll={refreshAll}
          />
        </>
      )}
      <Button variant="contained" color="secondary" onClick={handleGoBack}>
        Voltar
      </Button>
    </>
  )
}

export default SSOCorporateGroupForm
